export default {
      id: "i-wallet-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-wallet",
      toString: function () {
        return this.url;
      }
    }